import { alpha, Theme } from '@mui/material/styles';
import { glassPrintSurface } from '../glass';

// ----------------------------------------------------------------------

export default function Input(theme: Theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': {
              color: theme.palette.text.disabled,
            },
          },
          '@media print': {
            color: theme.palette.grey[900],
            backgroundColor: theme.palette.common.white,
            '&.Mui-disabled': {
              color: theme.palette.grey[700],
              WebkitTextFillColor: theme.palette.grey[700],
              backgroundColor: theme.palette.common.white,
              opacity: 1,
              '& svg': {
                color: 'inherit',
              },
            },
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
          '@media print': {
            color: theme.palette.grey[900],
            WebkitTextFillColor: theme.palette.grey[900],
            '&::placeholder': {
              color: theme.palette.grey[700],
              WebkitTextFillColor: theme.palette.grey[700],
              opacity: 1,
            },
            '&.Mui-disabled': {
              color: theme.palette.grey[700],
              WebkitTextFillColor: theme.palette.grey[700],
              opacity: 1,
            },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '@media print': {
            color: theme.palette.grey[900],
            '&.Mui-disabled': {
              color: theme.palette.grey[700],
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '@media print': {
            color: theme.palette.grey[900],
            '&.Mui-focused': {
              color: theme.palette.grey[900],
            },
            '&.Mui-disabled': {
              color: theme.palette.grey[700],
            },
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: alpha(theme.palette.grey[500], 0.56),
          },
          '&:after': {
            borderBottomColor: theme.palette.text.primary,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root.Mui-focused': {
            color: theme.palette.text.primary,
          },
          '@media print': {
            '& .MuiInputLabel-root': {
              color: theme.palette.grey[900],
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: theme.palette.grey[900],
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: theme.palette.grey[700],
            },
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: alpha(theme.palette.grey[500], 0.08),
          '&:hover': {
            backgroundColor: alpha(theme.palette.grey[500], 0.16),
          },
          '&.Mui-focused': {
            backgroundColor: alpha(theme.palette.grey[500], 0.16),
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          '&:before, :after': {
            display: 'none',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'light' ? 0.42 : 0.28),
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.grey[500], 0.32),
          },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: 1,
              borderColor: theme.palette.text.primary,
            },
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
          '@media (prefers-reduced-transparency: reduce)': {
            backgroundColor: alpha(theme.palette.background.paper, 0.96),
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
          '@media print': {
            ...glassPrintSurface(theme),
            '& .MuiInputBase-input': {
              color: theme.palette.grey[900],
              WebkitTextFillColor: theme.palette.grey[900],
              '&::placeholder': {
                color: theme.palette.grey[700],
                WebkitTextFillColor: theme.palette.grey[700],
                opacity: 1,
              },
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.grey[500],
            },
            '&.Mui-disabled': {
              color: theme.palette.grey[700],
              WebkitTextFillColor: theme.palette.grey[700],
              backgroundColor: theme.palette.common.white,
              opacity: 1,
              '& .MuiInputBase-input': {
                color: theme.palette.grey[700],
                WebkitTextFillColor: theme.palette.grey[700],
                opacity: 1,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.grey[500],
              },
            },
          },
        },
      },
    },
  };
}
